import { Link } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses';
import { t } from '../../common/i18n';
import { scrollIntoViewById } from '../../common/utils/htmlUtils';
import { Grid } from '../Grid/Grid';
import type { MouseEvent } from 'react';

const scrollToElement = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
  e.preventDefault();
  scrollIntoViewById(id);
};

export const PublicMobileVoiceHeader = () => {
  return (
    <>
      <header>
        <h1 className={dsClass.H1}>{t.ARE0('Telephone subscriptions for businesses')}</h1>
      </header>
      <Grid colWidthL={10}>
        <p className={`${dsClass.TEXT_LEAD} ${dsClass.TEXT_ALIGN_CENTER} ${dsClass.MARGIN_BOTTOM_0}`}>
          {t.N1QP(
            'With Elisa 5G business subscriptions, everything simply works better! Powerful and ultra-fast telephone subscriptions for business ensure seamless work, more stable connections and longer battery life. Additional services make your everyday work safer and more efficient.'
          )}
        </p>
        <p className={`${dsClass.TEXT_L} ${dsClass.TEXT_ALIGN_CENTER} ${dsClass.MARGIN_BOTTOM_0}`}>
          {t.WPBB(
            'Customize your business subscription to fit your needs: choose your speed, add the convenient add-on services:'
          )}
          &nbsp;
          <Link className={dsClass.LINK} onClick={e => scrollToElement(e, 'kukasoittaa')} to={{ hash: '#kukasoittaa' }}>
            Elisa Kuka Soittaa
          </Link>
          ,&nbsp;
          <Link
            className={dsClass.LINK}
            onClick={e => scrollToElement(e, 'mobiiliturva')}
            to={{ hash: '#mobiiliturva' }}
          >
            Elisa Mobiiliturva
          </Link>
          ,&nbsp;
          <Link
            className={dsClass.LINK}
            onClick={e => scrollToElement(e, 'mobiilivarmenne')}
            to={{ hash: '#mobiilivarmenne' }}
          >
            Elisa Mobiilivarmenne
          </Link>
          ,&nbsp;
          <Link
            className={dsClass.LINK}
            onClick={e => scrollToElement(e, 'matkapuhelinvastaaja')}
            to={{ hash: '#matkapuhelinvastaaja' }}
          >
            Elisa Matkapuhelinvastaaja
          </Link>
          &nbsp;{t.F43F('and')}&nbsp;
          <Link className={dsClass.LINK} onClick={e => scrollToElement(e, 'reissunetti')} to={{ hash: '#reissunetti' }}>
            Elisa Reissunetti
          </Link>
        </p>
      </Grid>
    </>
  );
};
